module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar attributes = model.nrOfElementsAttributes || {}\n%>\n<table>\n<tbody>\n<%\nif(config.showSelectedElements){\n%>\n<tr>\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfSelectedElements') %>:</td>\n<td class=\"value\"><%= model.nrOfSelectedElements || 0 %></td>\n</tr>\n<%\n}\n%>\n<tr>\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfElements') %>:</td>\n<td class=\"value\"><%= attributes.nrOfVisibleElements || 0 %></td>\n</tr>\n<tr>\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfMatchingElements') %>:</td>\n<td class=\"value\"><%= attributes.nrOfMatchingElements || 0 %></td>\n</tr>\n<tr class=\"row\">\n<td class=\"name\"><%= storage.__(config.translationPrefix + '.summary.nrOfAllElements') %>:</td>\n<td class=\"value\"><%= (attributes.nrOfElements || 0) %></td>\n</tr>\n</tbody>\n</table>"
  , __filename = "..\\frontend-controller\\baseComponents\\tableSimple\\summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var attributes = model.nrOfElementsAttributes || {}

    ; __line = 3
    ; __append("\n<table>\n<tbody>\n")
    ; __line = 6
    ; 
if(config.showSelectedElements){

    ; __line = 8
    ; __append("\n<tr>\n<td class=\"name\">")
    ; __line = 10
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfSelectedElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 11
    ; __append(escapeFn( model.nrOfSelectedElements || 0 ))
    ; __append("</td>\n</tr>\n")
    ; __line = 13
    ; 
}

    ; __line = 15
    ; __append("\n<tr>\n<td class=\"name\">")
    ; __line = 17
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 18
    ; __append(escapeFn( attributes.nrOfVisibleElements || 0 ))
    ; __append("</td>\n</tr>\n<tr>\n<td class=\"name\">")
    ; __line = 21
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfMatchingElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 22
    ; __append(escapeFn( attributes.nrOfMatchingElements || 0 ))
    ; __append("</td>\n</tr>\n<tr class=\"row\">\n<td class=\"name\">")
    ; __line = 25
    ; __append(escapeFn( storage.__(config.translationPrefix + '.summary.nrOfAllElements') ))
    ; __append(":</td>\n<td class=\"value\">")
    ; __line = 26
    ; __append(escapeFn( (attributes.nrOfElements || 0) ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>")
    ; __line = 29
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tableSimple\summary.ejs

}